import React, { useState } from 'react';
import { ModalBody, Modal, Button, Input, FormGroup, Label, ModalHeader, ModalFooter } from 'reactstrap';
import { raiseIssue } from '../../../../service/infinitetableproperties/action';
import { useDispatch } from 'react-redux';
import _map from 'lodash/map';

const RaiseTicket = ({ isModalOpen, updateModal, setMessages }) => {
    const dispatch = useDispatch();
    const [state, updateState] = React.useState({
        title: '',
        description: '',
        // email: '',
        priority: '',
    });
    const { title, description, email, priority } = state;
    const createIssue = async () => {
        dispatch(raiseIssue(state, setMessages));
        updateModal();
    };

    const prioritySelection = ['Low', 'Lowest', 'Medium', 'High', 'Highest'];

    return (
        <Modal isOpen={isModalOpen} centered size="xl" scrollable style={{ width: '500px' }}>
            <ModalHeader toggle={() => updateModal()}>Raise Issue</ModalHeader>
            <ModalBody>
                <FormGroup className="mb-2 mx-2 mr-sm-2 mb-sm-3 my-2">
                    <Label className={'mx-1 my-0'}>Title</Label>
                    <Input
                        type="text"
                        name="title"
                        value={title}
                        placeholder="Title"
                        onChange={({ target: { value } }) => updateState({ ...state, title: value })}
                    />
                </FormGroup>
                <FormGroup className="mb-2 mx-2 mr-sm-2 mb-sm-3 my-2">
                    <Label className={'mx-1 my-0'}>Description</Label>
                    <Input
                        type="textarea"
                        name="description"
                        value={description}
                        placeholder="description"
                        onChange={({ target: { value } }) => updateState({ ...state, description: value })}
                    />
                </FormGroup>
                {/* <FormGroup className="mb-2 mx-2 mr-sm-2 mb-sm-3 my-2">
                    <Label className={'mx-1 my-0'}>Email</Label>
                    <Input
                        type="text"
                        name="email"
                        value={email}
                        placeholder="email"
                        onChange={({ target: { value } }) => updateState({ ...state, email: value })}
                    />
                </FormGroup> */}
                <FormGroup className="mb-2 mx-1 mr-sm-2 mb-sm-0 my-2">
                    <Label className={'mx-2'}>Priority</Label>
                    <Input
                        type="select"
                        name="priority"
                        value={priority}
                        onChange={({ target: { value } }) =>
                            updateState({
                                ...state,
                                priority: value,
                            })
                        }
                    >
                        <option value="Select Priority"> Select Priority</option>
                        {_map(prioritySelection, (priorityType, index) => (
                            <option key={priorityType} value={priorityType}>
                                {' '}
                                {priorityType}{' '}
                            </option>
                        ))}
                    </Input>
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button type="button" className="ml-auto">
                    Cancel
                </Button>
                <Button type="button" onClick={() => createIssue()}>
                    Submit
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default RaiseTicket;
